import { dapBffBaseUrl } from '@dap/bff/config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuthState } from '@shared/state/auth';

const dapBffBaseQuery = fetchBaseQuery({
  baseUrl: dapBffBaseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as { auth: AuthState }).auth.token;

    if (!token) {
      throw new Error('No access token');
    }
    headers.set('authorization', `Bearer ${token}`);
    return headers;
  },
});

export const dapBffApi = createApi({
  reducerPath: 'dapBff',
  baseQuery: dapBffBaseQuery,
  endpoints: () => ({}),
});
